module.exports = __webpack_public_path__ + "img/arrow-left-aux.ec0e963c.svg";